export const CoreDataSecurityMonitorsName = 'CoreDataSecurityMonitors';
